import _merge from 'lodash/merge';
import { getLogger } from '../logger';
import { createSelectors as createEntitySelectors } from './entity-descriptor';
import { createAutocomplete } from './autocomplete-descriptor';

/* eslint-disable import/prefer-default-export */

const logger = getLogger('moduledescriptor');

if (!global.reduxModules) {
  global.reduxModules = {};
}

function moduleReducer(moduleDescriptor, entities, reducer = state => state) {
  return (state, action) => {
    logger.trace('Module reduce of', moduleDescriptor.name, 'Reducer', reducer);

    const moduleState = reducer(state, action);

    const newStateWithEntities = entities.reduce((state, entity) => {
      const entityState = state[entity.name];
      const entityReducer = entity.__reducer;
      logger.trace('Entity reduce with', entity.name, entityReducer);
      if (entityReducer) {
        const newEntityState = entityReducer(entityState, action);
        logger.trace('Entity state', entity.name, newEntityState);
        if (newEntityState !== entityState) {
          return { ...state, [entity.name]: newEntityState };
        }
      }

      return state;
    }, moduleState || {});

    logger.trace('Module state of', moduleDescriptor.name, 'State', newStateWithEntities);

    return newStateWithEntities;
  };
}

function initialize(moduleDescriptor, entities, reducer) {
  logger.debug('Initialize module reducer', moduleDescriptor.name, 'Reducer', reducer);
  // eslint-disable-next-line no-param-reassign
  moduleDescriptor.__reducer = moduleReducer(moduleDescriptor, entities, reducer);
}

function createDelegatingReducer(reducers) {
  const productionReducers = reducers.filter(reducer => !!reducer);
  return function delegatingReducer(currentState, action) {
    return productionReducers.reduce((state, reducer) => reducer(state, action), currentState);
  };
}

export function createModuleDescriptor(
  moduleName,
  {
    entities = [],
    uploads = [],
    reducer,
    saga = [],
    selectors = {},
    actions = {},
    config = {},
    helpers = {},
    autocomplete = [],
    createReducer = () => undefined,
  }
) {
  let moduleDescriptor = global.reduxModules[moduleName];
  if (!moduleDescriptor) {
    moduleDescriptor = { name: moduleName };
    entities.forEach(entity => {
      moduleDescriptor[entity.name] = entity;
      // eslint-disable-next-line no-param-reassign
      entity.selectors = createEntitySelectors(moduleName, entity);
    });
    uploads.forEach(upload => {
      moduleDescriptor[upload.name] = upload;
      // eslint-disable-next-line no-param-reassign
      // upload.selectors = createUploadSelectors(moduleName);
    });
    moduleDescriptor.selectors = selectors;
    moduleDescriptor.actions = actions;
    moduleDescriptor.helpers = helpers;
    moduleDescriptor.autocomplete =
      autocomplete && autocomplete.length > 0 ? createAutocomplete(moduleName, autocomplete) : {};
    moduleDescriptor.__config = config || {};
    moduleDescriptor.__initialize = config =>
      initialize(
        moduleDescriptor,
        entities,
        createDelegatingReducer([
          reducer,
          moduleDescriptor.autocomplete.__reducer,
          createReducer && createReducer(config),
        ])
      );
    moduleDescriptor.__sagas = [
      ...saga,
      ...entities.map(entity => entity.__saga),
      Object.values(moduleDescriptor.autocomplete)
        .map(auto => auto.__saga)
        .filter(saga => !!saga),
    ];
    global.reduxModules[moduleName] = moduleDescriptor;
  }
  return moduleDescriptor;
}
